import React, { useState } from "react";
import { Wallet, RefreshCw, Eye, EyeOff } from "lucide-react";
import { fetchUserBalance } from "../../services/api";

const BalanceCard = ({ userId }) => {
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [balance, setBalance] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [verified, setVerified] = useState(false);

  const handleCheckBalance = async () => {
    setLoading(true);
    setErrorMsg("");
    setBalance(null);

    try {
      const token = localStorage.getItem("adminToken");
      const storedUserId = userId || localStorage.getItem("userId");

      const result = await fetchUserBalance(storedUserId, password, token);
      setBalance(result.balance);
      setVerified(true);
    } catch (error) {
      console.error("Balance fetch failed:", error);
      setErrorMsg(error.message || "Invalid password");
    } finally {
      setLoading(false);
    }
  };

  const handleRefresh = () => {
    if (!verified) return;
    handleCheckBalance();
  };

  return (
    <div className="balance-card card shadow-sm border-0 text-center mx-auto theme-card-white">
        <div className="d-flex justify-content-center align-items-center mb-4 flex-column">
          <div className="icon-wrapper mx-auto mb-2">
            <Wallet size={32} className="text-theme" />
          </div>
          <h5 className="fw-semibold theme-text-black pb-1">Wallet Balance</h5>
          <p className="text-muted text-sm mb-0 theme-text-color">Enter your password to view your balance.</p>
        </div>

        {!verified ? (
          <>
            <div className="mb-3 position-relative">
              <input
                type={showPassword ? "text" : "password"}
                className="form-control pe-5"
                placeholder="Enter password to view balance"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />

              <div className="position-absolute top-50 end-0 translate-middle-y pe-3 cursor-pointer"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <Eye size={18} /> : <EyeOff size={18} />}
              </div>
            </div>

            {errorMsg && (
              <p className="text-danger small mb-2">{errorMsg}</p>
            )}

            <div className="d-flex justify-content-center">
              <button
                className="theme-btn"
                onClick={handleCheckBalance}
                disabled={loading || !password}
              >
                {loading ? "Checking..." : "Check Balance"}
              </button>
            </div>
          </>
        ) : (
          <>
            <h3 className="head-sm font-600 theme-text-black mb-3">
              ₹{balance?.toFixed(2)}
            </h3>

            <div className="d-flex justify-content-center">
              <button
                className="theme-btn"
                onClick={handleRefresh}
                disabled={loading}
              >
                <RefreshCw size={18} className="me-2" />
                {loading ? "Refreshing..." : "Refresh Balance"}
              </button>
            </div>
          </>
        )}
    </div>
  );
};

export default BalanceCard;
